import React from 'react';
import { Check } from 'lucide-react';

export const Pricing = () => {
  const plans = [
    {
      duration: '1 Hari',
      price: 'Rp 7.000',
      features: [
        'Semua fitur otomasi',
        'Auto Accept & Skip',
        'Filter harga & area',
        'Auto Up Price',
        'Support 24/7',
      ],
      popular: false,
    },
    {
      duration: '30 Hari',
      price: 'Rp 45.000',
      features: [
        'Semua fitur otomasi',
        'Auto Accept & Skip',
        'Filter harga & area',
        'Auto Up Price',
        'Leaderboard penghasilan',
        'Anti-Hack protection',
        'Support prioritas',
      ],
      popular: true,
    },
    {
      duration: '90 Hari',
      price: 'Rp 95.000',
      features: [
        'Semua fitur otomasi',
        'Auto Accept & Skip',
        'Filter harga & area',
        'Auto Up Price',
        'Leaderboard penghasilan',
        'Anti-Hack protection',
        'Support prioritas',
        'Hemat 65%',
      ],
      popular: false,
    },
  ];

  return (
    <section
      id="pricing"
      style={{
        background: 'var(--bg-primary)',
        padding: '100px 7.6923%',
      }}
    >
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2
            style={{
              fontSize: '48px',
              fontWeight: 600,
              lineHeight: 1.1,
              letterSpacing: '-0.02em',
              color: 'var(--text-primary)',
              marginBottom: '16px',
            }}
          >
            Paket Akses BAiBOT
          </h2>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 500,
              lineHeight: 1.5,
              color: 'var(--text-secondary)',
            }}
          >
            Pilih paket yang sesuai dengan kebutuhan Anda
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px',
          }}
          className="pricing-grid"
        >
          {plans.map((plan, index) => (
            <div
              key={index}
              style={{
                background: plan.popular ? 'var(--bg-secondary)' : 'var(--bg-primary)',
                border: plan.popular
                  ? '2px solid var(--brand-primary)'
                  : '1px solid var(--border-subtle)',
                padding: '40px',
                position: 'relative',
                transition: 'all 0.4s ease-in-out',
              }}
              className="dark-hover"
            >
              {plan.popular && (
                <div
                  style={{
                    position: 'absolute',
                    top: '-16px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: 'var(--brand-primary)',
                    color: '#000000',
                    padding: '8px 24px',
                    fontSize: '14px',
                    fontWeight: 600,
                  }}
                >
                  PALING POPULER
                </div>
              )}
              <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                <h3
                  style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    color: 'var(--text-primary)',
                    marginBottom: '16px',
                  }}
                >
                  {plan.duration}
                </h3>
                <div
                  style={{
                    fontSize: '48px',
                    fontWeight: 600,
                    color: 'var(--brand-primary)',
                    lineHeight: 1,
                  }}
                >
                  {plan.price}
                </div>
              </div>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: '0 0 32px 0',
                }}
              >
                {plan.features.map((feature, idx) => (
                  <li
                    key={idx}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      marginBottom: '16px',
                      fontSize: '16px',
                      color: 'var(--text-secondary)',
                    }}
                  >
                    <Check size={20} color="var(--brand-primary)" />
                    {feature}
                  </li>
                ))}
              </ul>
              <a
                href="https://baiclopz.cloud/baibot/menu45.php"
                target="_blank"
                rel="noopener noreferrer"
                className={plan.popular ? 'btn-primary' : 'btn-secondary'}
                style={{
                  width: '100%',
                  textDecoration: 'none',
                }}
              >
                Beli Sekarang
              </a>
            </div>
          ))}
        </div>
      </div>
      <style>
        {`
          @media (max-width: 767px) {
            .pricing-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </section>
  );
};